import { Component } from '@angular/core';
import { BlockCardsWrapperComponent as CoreBlockCardsWrapperComponent } from '@gallaghercp/core-frontend';

/**
 * Local extension of the shared card wrapper.
 *
 * Register this component in LayoutModule while the wrapper changes are being
 * debugged here. Move the accepted changes into core-frontend afterwards.
 */
@Component({
    selector: 'core-client-cards-wrapper',
    templateUrl: './block-cards-wrapper.component.html',
    standalone: false,
})
export class BlockCardsWrapperComponent extends CoreBlockCardsWrapperComponent {
    override ngOnInit(): void {
        console.debug('[Cards wrapper debug] Initialising cards wrapper', {
            blockData: this.block?.data,
            blockId: this.block?.id,
        });

        super.ngOnInit();
    }
}
